import React, { useState, ChangeEvent, Dispatch, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import { get, isEmpty, uniqBy } from "lodash";
import { scrollToErrorOnFormHandler,cacheManager} from "../../../helpers/util-common";
import RenderTypeahead from "../../../shared-components/Typeahead";
import { getActiveCommitteesFromIAAction } from "../../../redux/action/ballots";
import { AddAdminWorkitemModalProps, AdminWorkitemProps } from "../interface";
import { Typeahead } from "react-bootstrap-typeahead";
import { getMemberListAction, addAdminWorkitemction, getWorkItemListAction } from "../../../redux/action/workItem";
import ReduxRadio from "../../../shared-components/Radio";

type Props = {
  committeeDesignationData: any[];
  selectedCommitteeDesignation: any[];
  setselectedCommitteeDesignation: Function;
  invalidCommittee: boolean;
  validateOnChange: Function;
  handleCommitteeSelectionInputKeyPress: Function;
  clearAllTypeaheds: boolean;
  customClass: string;
  selectedTitle: string;
  invalidTitle: boolean;
  onTitleChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  memberList: any[];
  technicalContact: any[];
  setTechnicalContact: Function;
  technicalContactRef: any;
  isLoadingMembers: boolean;
  setAdminWorkitem: Function;
};

const AppealOnCOSForm: React.FC<Props> = ({
    committeeDesignationData,
    invalidCommittee,
    clearAllTypeaheds,
    selectedCommitteeDesignation,
    customClass,
    validateOnChange,
    handleCommitteeSelectionInputKeyPress,
    invalidTitle,
    onTitleChange,
    selectedTitle,
    memberList,
    isLoadingMembers,
    technicalContactRef,
    technicalContact,
    setTechnicalContact,
    setAdminWorkitem,    
  }) => 
  {

const filteredCommitteeData = committeeDesignationData?.filter((item: any) => {
  return (
    item?.SubCommitteeId === null ||
    item?.CommitteeDesignation?.split(".")[0] === "COS"
  );
});

  return (
    <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    {committeeDesignationData && (
                      <div className="form-group">
                        <label htmlFor="WorkitemCommittee" className={`edit-label-name ${invalidCommittee ? "invalid-feedback block" : ""} `}>
                          <i aria-hidden="true" className="fas fa-asterisk"></i>
                          Committee
                        </label>
                        <Field name="WorkitemCommittee" clearTypeahead={clearAllTypeaheds} disabled={committeeDesignationData?.length === 0}
                         id="addAdminWorkitemCommittee" required={true} labelKey="CommitteeDesignation" value={selectedCommitteeDesignation} 
                         filterBy={["CommitteeDesignation"]} component={RenderTypeahead} placeholder={committeeDesignationData?.length === 0 ? "Fetching records..." : "Type here to select"} 
                         data-testid="addCOSAdminWorkitemCommittee" customClass={customClass} fieldError={invalidCommittee} options={filteredCommitteeData} selected={selectedCommitteeDesignation || []} 
                         defaultValue={selectedCommitteeDesignation} change={validateOnChange} keyDown={handleCommitteeSelectionInputKeyPress} />
                        {invalidCommittee && (
                          <div id="helpText" className="invalid-feedback block">
                            {"Committee is required."}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="w-100"></div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="Title" className={`edit-label-name ${invalidTitle ? "invalid-feedback block" : ""} `}>
                      <i aria-hidden="true" className="fas fa-asterisk"></i>
                      Title
                    </label>  
                    <textarea className={`form-control form-control-text-area-resize ${invalidTitle ? "is-invalid" : ""}`}  onChange={onTitleChange}  name="Title" data-testid="COSEmergencyDescription" id={"EmergencyDescription"} value={selectedTitle} placeholder="Click here to type" />
                    {invalidTitle && (
                      <div id="helpText" className="invalid-feedback">
                        {"Title is required."}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6 form-group">
                  <label htmlFor="TechnicalContactName">
                    <i aria-hidden="true"></i>Technical Contact
                  </label>
                  <Typeahead
                    key={memberList.length}
                    disabled={false}
                    id={"TechnicalContactName"}
                    className="technicalContactDropdown"
                    options={memberList}
                    emptyLabel={isLoadingMembers ? "Fetching records..." : "No match found."}
                    ref={technicalContactRef}
                    clearButton={true}
                    data-testid="COSTechnicalContactName"
                    onChange={(value) => {
                      setTechnicalContact(value);
                      setAdminWorkitem((prevState) => {
                        return { 
                          ...prevState, 
                          TechnicalContactId: value[0] && typeof value[0] === 'object' && value[0].hasOwnProperty('value') ? value[0].value : null
                    }});
                    }}
                    placeholder="Type here to select"
                    selected={technicalContact}
                  />
                  <div id="helpText" className="invalid-feedback"></div>
                </div>
              </div>
            </div>
  );
};

export default AppealOnCOSForm;